<template>
  <div class="survey-banner">
    <div class="text-center">
      <h2>{{ termsText }}</h2>
    </div>
    <p>
      <b>患者さんへ </b><br />
      当院で非結核性抗酸菌症ならびにほかの慢性肺感染症（肺非結核性抗酸菌症、気管支拡張症、肺真菌症など）の治療をされている患者さんにご提案およびお願いです。
    </p>
    <p>
      この度複十字病院では患者さんの慢性肺感染症の経過および現状、対する当院および他院からの医療提供状況を、我々診療に携わるスタッフ一同がタイムリーかつ詳細に把握・共有し、長期的かつ俯瞰的な視野で患者さん含め我々一同にフィードバックすることで医療の質向上と皆さんの疾患理解の助けとなることを目指した診療支援ツール、『複十字慢性肺感染症データベース』（以下、複十字lungデータベース）の構築を計画・実施することになりました。
    </p>
    <p>
      以下に示すこの計画の必要性やその趣旨をご理解いただき、ご賛同いただけるようでしたら、ご協力賜りますよう宜しくお願い申し上げます。
    </p>
    <p>
      患者さんが現在当院で治療されている肺疾患は、その長い治療経過で多岐にわたる膨大な臨床情報が蓄積されていくという特徴があることは、皆さまの日頃痛感されているところと存じます。患者さんご自身の自覚症状に始まり、既往疾患や複数の薬剤の使用歴とその副作用歴のみならず、患者さんの生活の質（Quality
      of
      Life；QOL）や心理社会的健康状態、ご自身をとりまく生活環境やご家族の既往歴などあらゆる事項がこの疾患の全体像の把握に非常に重要であるからです。加えて病院に来るたびに患者さんご自身の各検査結果（血液、喀痰、画像、生理機能、身体機能、など）だけでなく、菌側の情報（その種類や薬剤感受性結果など）も刻一刻と変化し累積していきます。患者さんの治療には多くの専門家（内科医、外科医、放射線科医、薬剤師、検査技師、理学療法士、栄養士、看護師、臨床心理士、公衆衛生検査機関、基礎医学研究者、社会福祉士など）が関わり、互いに連携・協力しながら適切な治療方針を導き出していく必要があるので、個々の患者さんのその膨大な情報を我々スタッフ一同が常に共有・活用していくことが重要です。中には一つの些細な変化や結果の認識や解釈、その共有が不十分である場合、後々患者さんの経過に大きな違いが出てくることすらあり得ます。たとえば薬物治療や手術の内容およびその時期の決定などがそれにあたります。
    </p>
    <p>
      また患者さんご自身も症状変化が些細であったり、長い経過の中での慣れもあり、ご自身も見過ごしたり、軽視したりすることもあるかもしれません。今ご自分になされている治療内容やその効果、必要性あるいは起こりうる副作用について納得のいくように理解し、担当医師と適切なコミュニケーションをとりながらご自分に最もあった治療を選択し続けていく、という作業は非常に負担が大きく困難で、不安も多いのではないでしょうか。それはおそらく患者さんの周りの方々（ご家族やご友人あるいは職場の方など）にとっては尚更困難なことだと思います。複十字lung
      データベースの構築は患者さんご自身がご自分の疾患の状況をよりわかりやすい形で担当医師と確認いただけることを第一に目指します。そして患者さんが今後の生活の見通しについて周りの方々と共有し、不安な点に焦点をあて話し合い解決していく糸口となるべく、皆さんにご理解いただく必要のある部分を、より見える化した形でコンパクトにまとめて提供できることを目指したいと思います。
    </p>
    <p>
      以上のような課題の解決、よりよい情報管理・伝達を可能とするシステムがまさに求められており、今からご説明する診療支援ツールとしてのデータベースを構築することを計画いたしました。このデータベースの最大の特徴は、患者さんのアンケート結果（疾患に関わる症状や心理社会的健康状態の評価）の経過を主軸・骨組みとして、他の医療データを肉付け・紐付けしていく仕組みとなっている、つまり患者中心型（Patient
      centered
      model)であることです。このような仕組みにすることで、顧客を中心としてシステム向上を追求する商業ベースのデータ活用技術をこの医療現場に積極的に取り入れ、患者さんのニーズによりあったデータ提供あるいは医療者とのコミュニケーションツールを医療者目線でなく患者目線で構築できると考えています。
    </p>
    <p>
      一方、複数の患者さんから集めるこの情報を人工知能をもちいて比較・分類など解析・検討することで疾患の新しい知見や治療法への糸口が見つかる可能性もあります。
    </p>
    <p>
      この計画はそのように慢性肺感染症の医療をより適切に提供する取り組みの直接支援するツールとなり、また必要とされる人材や医療資材の適正配備につながることを目指しています。
    </p>
    <div>
      <p><b>1．本計画への参加について</b></p>
      <p>
        本計画への参加は、患者さんの自由な意思に基づくものであり、参加されたくない場合は、データ登録を拒否して頂くことができます。なお、登録を拒否されたことで、日常の診療等において患者さんが不利益を被ることは一切ございません。
      </p>
    </div>
    <div>
      <p><b>2．データ登録の目的 </b></p>
      <p>
        慢性肺感染症の個々の患者さんにより良い医療を病院として提供していくために、医療提供状況を俯瞰的に把握し研究することは重要です。複十字lungデータベースでは体系的に登録された情報に基づいて、医療の質改善に向けた検討を継続的に行います。
      </p>
      <p>
        自施設の特徴と課題を把握し、その改善に向けた取り組みを行う上で、患者さん中心に構築・収集された各領域のデータを俯瞰的に評価し、活用した学術研究を行うことで、医療の質向上を図ります。
      </p>
    </div>
    <div>
      <p><b>3．登録される情報の内容 </b></p>
      <p>
        登録される情報は患者さんの治療経過、既往歴や合併症、本疾患による日常の症状経過記録およびアンケート結果、病院で行われているあらゆる検査結果、手術等も含む各種治療内容その時期、短期
        および長期の経過、治療成績、などとなります。これらの情報は、それ自体で患者さん個人を容易に特定することはできないものですが、患者さんに関わる重要な情報ですので厳重に管理いたします。具体的な情報の取り扱いや安全管理
        にあたっては、関連する法令や取り決め（「個人情報保護に関する法律」、「人を対象とする医学系研究に関する
        倫理指針」、「医療・介護関連事業者における個人情報の適切な取り扱いのためのガイダンス」、「医療情報シス
        テムの安全管理に関するガイドライン」等）を遵守しています。登録されたご自身のデータをご覧になりたい場合は、受診された診療科にお問
        い合わせ下さい。
      </p>
    </div>
    <div>
      <p><b>4．登録される情報の使われ方 </b></p>
      <p>
        登録される情報は、患者さんと患者さんと同じないし類似した疾患の治療成績向上ならびに皆さまの健康の向上に役立てるために、担当医師との外来にフィードバックされます。また、各領域が主導して慢性肺感染症治療の質向上を目的とした学術研究のために活用
        されます。この際に用いられる情報は集計・分析後の統計情報のみとなりますので、患者さん個人を特定可能な形
        で、複十字lungデータベース
        が情報公表することは一切ありません。なお、治療成績を適切に評価するために、他医療機関と連携した形で研究が行われる場合があります。情報の公開にあたっても、当院の倫理委員会および
        各専門家内で十分議論し、そこで承認を受けた情報のみが公開の対象となります。
      </p>
    </div>
    <div>
      <p>
        お問い合わせについては受診された担当医または呼吸器外科平松までご連絡下さい。
      </p>
    </div>
    <div class="mt-5">
      <h4 class="font-weight-bold">本システム利用規約</h4>
      <p>
        この利用規約（以下，「本規約」といいます。）は、複十字病院（以下，「当院」といいます。）が院内LANを利用して患者さんがご利用いただく臨床支援システム，「複十字lungデータベース」といいます。）の利用条件を定めるものです。登録患者さんは，この規約に従って本システムをご利用いただきます。
      </p>
      <h6 class="font-weight-bold">第1条（適用）</h6>
      <p>
        この規約は，患者さんと当院との間の本システムの利用に関わる一切の関係に適用されるものとします。
      </p>
      <p>
        当院は本システムに関し，本規約のほか，ご利用にあたってのルール等，各種の定め（以下，「個別規定」といいます。）をすることがあります。これら個別規定はその名称のいかんに関わらず，本規約の一部を構成するものとします。
      </p>
      <p>
        本規約の規定が前条の個別規定の規定と矛盾する場合には，個別規定において特段の定めなき限り，個別規定の規定が優先されるものとします。
      </p>
      <h6 class="font-weight-bold">第2条（臨床情報入力）</h6>
      <p>
        本システムにおいては，登録希望者が本規約に同意をいただいた上で，当院の定める臨床情報が入力できるようになり，これを我々が確認の上データベースに移行することで患者さんの本システム利用登録が完了するものとします。
      </p>
      <p>
        当院は，利用登録の申請者に以下の事由があると判断した場合，入力内容をデータベースに移行しないことがあり，その理由については一切の開示義務を負わないものとします。
      </p>
      <p>臨床情報入力に際して虚偽の事項を届け出た場合</p>
      <p>本規約に違反したことがある者の情報入力である場合</p>
      <p>その他，当院が入力内容のデータベース移行に適切でないと判断した場合</p>
      <h6 class="font-weight-bold">第3条（患者IDおよびパスワードの管理）</h6>
      <p>
        患者さんは，自己の責任において，本システムのパスワードを適切に管理するものとします。
      </p>
      <p>
        患者さんは，いかなる場合にも，患者IDおよびパスワードを第三者に貸与する，もしくは第三者と共用することはできません。当院は，患者IDとパスワードの組み合わせが登録情報と一致してログインされた場合には，その患者IDを登録している患者自身による利用とみなします。
      </p>
      <p>
        患者ID及びパスワードが第三者によって使用されたことによって生じた損害は，当院に故意又は重大な過失がある場合を除き，当院は一切の責任を負わないものとします。
      </p>
      <h6 class="font-weight-bold">第4条（禁止事項）</h6>
      <p>
        患者さんは，本システムの利用にあたり，以下の行為をしてはなりません。
      </p>
      <p>
        本システムの内容等，本システムに含まれる著作権，商標権ほか知的財産権を侵害する行為
      </p>
      <p>
        当院，ほかの患者さん，またはその他第三者のサーバーまたはネットワークの機能を破壊したり，妨害したりする行為
      </p>
      <p>本システムによって得られた情報を商業的に利用する行為</p>
      <p>当院のシステムの運営を妨害するおそれのある行為</p>
      <p>不正アクセスをし，またはこれを試みる行為</p>
      <p>他の患者さんに関する個人情報等を収集または蓄積する行為</p>
      <p>不正な目的を持って本システムを利用する行為</p>
      <p>
        本システムの他の患者さんまたはその他の第三者に不利益，損害，不快感を与える行為
      </p>
      <p>他の患者さんに成りすます行為</p>
      <p>その他，当院が不適切と判断する行為</p>
      <h6 class="font-weight-bold">第5条（本システムの提供の停止等）</h6>
      <p>
        当院は，以下のいずれかの事由があると判断した場合，患者さんに事前に通知することなく本システムの全部または一部の提供を停止または中断することができるものとします。
      </p>
      <p>
        本システムにかかるコンピュータシステムの保守点検または更新を行う場合
      </p>
      <p>
        地震，落雷，火災，停電または天災などの不可抗力により，本システムの提供が困難となった場合
      </p>
      <p>コンピュータまたは通信回線等が事故により停止した場合</p>
      <p>その他，当院が本システムの提供が困難と判断した場合</p>
      <p>
        当院は，本システムの提供の停止または中断により，患者さんまたは第三者が被ったいかなる不利益または損害についても，一切の責任を負わないものとします。
      </p>
      <h6 class="font-weight-bold">第6条（利用制限および登録抹消）</h6>
      <p>
        当院は，患者さんが以下のいずれかに該当する場合には，事前の通知なく，患者さんに対して，本システムの全部もしくは一部の利用を制限し，またはその患者さんが入力された臨床情報を抹消することができるものとします。
      </p>
      <p>本規約のいずれかの条項に違反した場合</p>
      <p>登録事項に虚偽の事実があることが判明した場合</p>
      <p>当院からの連絡に対し，一定期間返答がない場合</p>
      <p>その他，当院が本システムの利用を適当でないと判断した場合</p>
      <p>
        当院は，本条に基づき当院が行った行為により患者さんに生じた損害について，一切の責任を負いません。
      </p>
      <h6 class="font-weight-bold">第7条（退システム）</h6>
      <p>
        患者さんは，当院の定める手続により，本システムから退システムできるものとします。
      </p>
      <h6 class="font-weight-bold">第8条（保証の否認および免責事項）</h6>
      <p>
        当院は，本システムに事実上または法律上の瑕疵（安全性，信頼性，正確性，完全性，有効性，特定の目的への適合性，セキュリティなどに関する欠陥，エラーやバグ，権利侵害などを含みます。）がないことを明示的にも黙示的にも保証しておりません。
      </p>
      <p>
        前項ただし書に定める場合であっても，当院は，当院の過失（重過失を除きます。）による不法行為により患者さんに生じた損害のうち特別な事情から生じた損害（当院または患者さんが損害発生につき予見し，または予見し得た場合を含みます。）について一切の責任を負いません。当院は，本システムに関して，患者さんと他の患者さんまたは第三者との間において生じた連絡または紛争等について一切責任を負いません。
      </p>
      <h6 class="font-weight-bold">第9条（システム内容の変更等）</h6>
      <p>
        当院は，患者さんへの事前の告知をもって、本システムの内容を変更、追加または廃止することがあり、患者さんはこれを承諾するものとします。
      </p>
      <h6 class="font-weight-bold">第10条（利用規約の変更）</h6>
      <p>
        当院は以下の場合には、患者さんの個別の同意を要せず、本規約を変更することができるものとします。
      </p>
      <p>本規約の変更が患者さんの一般の利益に適合するとき。</p>
      <p>
        本規約の変更が本システム利用契約の目的に反せず、かつ、変更の必要性、変更後の内容の相当性その他の変更に係る事情に照らして合理的なものであるとき。
      </p>
      <h6 class="font-weight-bold">第11条（個人情報の取扱い）</h6>
      <p>
        当院は，本システムの利用によって取得する個人情報について，当院「プライバシーポリシー」（前述）に従い適切に取り扱うものとします。
      </p>
      <h6 class="font-weight-bold">第12条（通知または連絡）</h6>
      <p>
        患者さんと当院との間の通知または連絡は，当院の定める方法によって行うものとします。当院は,患者さんから,当院が別途定める方式に従った変更届け出がない限り,現在登録されている連絡先が有効なものとみなして当該連絡先へ通知または連絡を行います。
      </p>
      <h6 class="font-weight-bold">第13条（情報入力のなりすましの禁止）</h6>
      <p>患者さんは，IDおよびパスワードを第三者に供することはできません。</p>
    </div>
    <div class="text-center m-5">
      <h2>プライバシーポリシー</h2>
    </div>
    <div>
      <h6 class="font-weight-bold">基本方針</h6>
      <p>
        当院は、個人情報の重要性を認識し、個人情報を保護することが社会的責務であると考え、個人情報に関する法令を遵守し、当院で取扱う個人情報の取得、利用、管理を適正に行います。
      </p>
      <h6 class="font-weight-bold">適用範囲</h6>
      <p>
        本プライバシーポリシーは、患者さんの個人情報もしくはそれに準ずる情報を取り扱う際に、当院が遵守する方針を示したものです。
      </p>
      <h6 class="font-weight-bold">個人情報の利用目的</h6>
      <p>
        当院は、患者さんからご提供いただく情報を以下の目的の範囲内において利用します。
      </p>
      <p>医学学術研究のため</p>
      <p>ご本人確認のため</p>
      <p>システムの提供・改善・開発のため</p>
      <p>
        患者さんの承諾・申込みに基づく、共同研究者・団体等への個人情報の提供のため
      </p>
      <p>その他個別に承諾いただいた目的</p>
      <h6 class="font-weight-bold">個人情報の管理</h6>
      <p>
        当院は、個人情報の正確性及び安全確保のために、セキュリティ対策を徹底し、個人情報の漏洩、改ざん、不正アクセスなどの危険については、必要かつ適切なレベルの安全対策を実施します。
      </p>
      <p>
        当院は、第三者に重要な情報を読み取られたり、改ざんされたりすることを防ぐために、SSLによる暗号化を使用しております。
      </p>
      <h6 class="font-weight-bold">個人情報の第三者提供</h6>
      <p>
        当院は、以下を含む正当な理由がある場合を除き、個人情報を第三者に提供することはありません。
      </p>
      <p>ご本人の同意がある場合</p>
      <p>法令に基づく場合</p>
      <p>人の生命・身体の保護に必要な場合</p>
      <p>公衆衛生・児童の健全育成に必要な場合</p>
      <p>
        当院では、利用目的の達成に必要な範囲内において、他の事業者へ個人情報を個人が特定できない形で提供することがあります。
      </p>
      <p>個人情報に関するお問い合わせ</p>
      <p>
        開示、訂正、利用停止等のお申し出があった場合には、所定の方法に基づき対応致します。具体的な方法については、個別にご案内しますので、お問い合わせください。
      </p>
      <h6 class="font-weight-bold">Cookie（クッキー）</h6>
      <p>
        Cookie（クッキー）は、利用者の入力および閲覧履歴を、利用者のコンピュータに保存しておく仕組みです。
      </p>
      <p>
        利用者はCookie（クッキー）を無効にすることで収集を拒否することができますので、お使いのブラウザの設定をご確認ください。ただし、Cookie（クッキー）を拒否した場合、当院のいくつかのシステム・機能が正しく動作しない場合があります。
      </p>
      <h6 class="font-weight-bold">アクセス解析</h6>
      <p>
        当院では、情報の分析と改善のためにGoogleが提供している「Google
        アナリティクス」を利用しています
      </p>
      <p>
        このシステムは、トラフィックデータの収集のためにCookie（クッキー）を使用しています。トラフィックデータは匿名で収集されており、個人を特定するものではありません。
      </p>
      <h6 class="font-weight-bold">免責事項</h6>
      <p>
        当院のコンテンツ・情報について、可能な限り正確な情報を掲載するよう努めておりますが、正確性や安全性を保証するものではありません。当院に掲載された内容によって生じた損害等の一切の責任を負いかねますのでご了承ください。
      </p>
      <h6 class="font-weight-bold">著作権・肖像権</h6>
      <p>
        当院で掲載しているすべてのコンテンツ（文章、画像、動画、音声、ファイル等）の著作権・肖像権等は当院所有者または各権利所有者が保有し、許可なく無断利用（転載、複製、譲渡、二次利用等）することを禁止します。また、コンテンツの内容を変形・変更・加筆修正することも一切認めておりません。
      </p>
      <p>
        各権利所有者におかれましては、万一掲載内容に問題がございましたら、ご本人様よりお問い合わせください。迅速に対応いたします。
      </p>
      <h6 class="font-weight-bold">本プライバシーポリシーの変更</h6>
      <p>
        当院は、本プライバシーポリシーの内容を適宜見直し、その改善に努めます。
      </p>
      <p>本プライバシーポリシーは、事前の予告なく変更することがあります。</p>
    </div>
    <div class="text-center m-5">
      <h2>秘密保持契約書</h2>
    </div>
    <div>
      <p>
        　　　　　　　と結核予防会複十字病院は（以下「当院」と言う。）とは、『複十字慢性肺感染症データベース』構築に関し、相互に開示する秘密情報の取扱いについて、次のとおり秘密保持契約を締結する。
      </p>
      <p>
        （秘密情報） 第1条
        本契約において秘密情報とは、患者さんの臨床情報および病院のシステム情報等すべてであり
      </p>
      <p><b>(1) 取得した時に既に公知、公用となっていたもの</b></p>
      <p>
        <b
          >(2) 取得した後に受領当事者の責によることなく公知、公用となったもの
        </b>
      </p>
      <p><b>(3) 取得する以前に守秘義務を負うことなく既に知得していたもの</b></p>
      <p>
        <b
          >(4)
          正当な権利を有する第三者から守秘義務を負うことなく合法的に取得したもの
          （秘密保持義務）</b
        >
      </p>
      <p>
        当院は秘密情報を開示又は漏洩してはならない。 ２．
        前項にかかわらず、受領当事者は、以下の関係者に対し、本件業務に必要な範囲内で、事前に開示当事者の書面による承諾を得ることなく秘密情報を開示することができる。ただし、受領当事者は秘密情報
        の開示を受ける者に対し、本契約に定める秘密保持義務と同等の秘密保持義務を遵守させなければなら
        ない。
      </p>
      <p>
        (1)
        受領当事者の役員および従業員で、本件業務の履行に従事し、かつ、秘密情報の開示を受けることが
        必要な者
      </p>
      <p>
        (2)
        受領当事者が本件業務を委託する者の役員および従業員で、本件業務の履行に従事し、かつ、秘密情
        報の開示を受けることが必要な者
      </p>
      <p>
        (3)
        受領当事者が本件業務について相談する必要がある弁護士、公認会計士、税理士、不動産鑑定士等の
        専門家 ３．
        受領当事者は、前項の開示を行った時は、開示当事者に書面で報告しなければならない。
      </p>
      <p>
        ４． 第 1
        項にかかわらず、次に揚げる場合については、受領当事者は秘密情報を開示することができる。
        ただし、受領当事者は、開示を行う前に開示当事者に対して、当該開示の時期、方法および手段につ
        いて協議するために最善の努力をなすものとする。
      </p>
      <p>(1) 法令又は官公署の命令により開示することが要求される場合</p>
      <p>
        (2)
        官公署からの要請等、受領当事者による開示に正当な理由があるものと受領当事者が合理的に判断し
        た場合 （教育） 第3条
        甲および乙は、関係者に対し、本契約に定める事項を十分に説明するとともに、秘密保持義務を遵守す
        るよう教育・周知の対策を講じなければならない。 （管理） 第4条
        甲および乙は、本契約の趣旨に則り、秘密情報を善良なる管理者の注意義務をもって管理する。
        ２．
        受領当事者は、開示当事者から開示された秘密情報について、厳重に管理の上、関係者のみの取扱い
        とし、第三者に貸与、譲渡等してはならない。また、開示当事者からの返還もしくは廃棄の要請があ
        る場合、それに従う。
      </p>
      <p>
        ３．
        受領当事者は、開示当事者から開示された秘密情報を本件業務の目的にのみ使用するものとし、事前
        に開示当事者の書面による承諾を得ることなく他のいかなる目的にも使用しない。
        （開示当事者による監督） 第5条
        開示当事者は、受領当事者に対し、必要に応じて、秘密情報の管理状況に関する報告等を求めることが
        できるとともに、本契約の履行確保のために、受領当事者に対し管理状況の改善を要請することができ
        る。 （権利帰属） 第6条
        秘密情報に係る権利は、秘密情報が無体物又は有体物であるかにかかわらず、全て開示当事者に帰属す
        る。当該権利には、著作権および産業財産権等の知的財産権、所有権その他一切の権利を含む。
      </p>
      <p>
        ２．
        本契約に基づき著作権および産業財産権等の知的財産権に関する情報を開示当事者が開示したことを
        もって、それらの知的財産権について受領当事者に譲渡又は許諾するものではない。
        （秘密情報の返還および廃棄） 第7条
        受領当事者は、本件業務の履行が終了する場合および開示当事者から要請があった場合は、開示当事者
        の指示に従い、開示当事者から提供を受けた秘密情報ならびにその複製物および複写物の全てを開示当
        事者に返還又は廃棄しなければならない。 ２．
        前項にかかわらず、法令で保管義務等の定めのある文書等については当該法令の定めに従う。
        （損害賠償） 第8条
        受領当事者は､秘密情報の漏洩等の事故が生じた場合には、速やかに開示当事者に対しこれを報告し、
        開示当事者の指示を受けるものとする。
      </p>
      <p>
        ２．
        受領当事者が本契約に定める事項に違反したことにより、開示当事者が損害を被った場合、受領当事者
        は開示当事者が被った損害を賠償するものとする。ただし、開示当事者に生じた間接損害、特別損害お
        よび逸失利益については、受領当事者は責任を負わないものとする。 （期間）
        第9条 本契約の有効期間は、本件業務の履行が終了するまでとする。
      </p>
      <p>
        ２． 前項にかかわらず、第 2 条（秘密保持義務）、第 4 条（管理）、第 6
        条（権利帰属）および第 8 条（損
        害賠償）は本契約の終了後も有効に存続する。 （解除） 第10条
        甲および乙は、相手方が本契約に定める条項の一に違反したときは、本件業務の委託契約を解除するこ
        とができる。 （管轄） 第11条
        本契約について争いが生じたときは、○○地方裁判所を第一審の専属的合意管轄裁判所とする｡
        （その他） 第12条
        本契約に定めのない事項又は疑義が生じた場合、甲および乙は互いに誠意を持って協議のうえ、円滑に
        解決を図るものとする。 本契約締結の証として、本書 2
        通を作成し、甲乙記名押印の上各 1 通を保管する。西暦　202○年○月○日
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      termsText: "利用規約",
    };
  },
  created() {
    this.setLanguage(this.$store.state.siteLanguage);
  },
  computed: {
    SiteLanguage() {
      return this.$store.state.siteLanguage;
    },
  },
  watch: {
    SiteLanguage(newSiteLanguage, oldSiteLanguage) {
      this.setLanguage(newSiteLanguage);
    },
  },
  methods: {
    setLanguage(siteLanguage) {
      if (siteLanguage === "ja") {
        this.termsText = "規約と条件";
      } else {
        this.termsText = "Terms and conditions";
      }
    },
  },
};
</script>

<style scoped>
.survey-banner {
  padding: 150px 90px 65px 90px;
}
</style>